<!--
<div>

  <p class="first-letter">
    Tong Yang agricultural machine<br />
    &nbsp;&nbsp;pursure abundant rural community.
  <p style="font-size: 3em !important; color: #dd000f; ">
    TYM</p>
    pursure abundant rural community.

  <h1 style="position: relative; left: 50%;">협력업체 <strong>VAN</strong> System</h1>
</div>

<hr />
-->
<div class="container">

  <div class="mainTxt">
    
      Welcome to <br />
      Cooperative firm <br />
      VAN system
    
  </div>

  <!--<div class="div">   
    
    <p style="text-align: left;">
      최첨단 기술과 설비를 바탕으로 완벽한 품질을 추구해 온 <span style="font-size: 2em !important; color: #dd000f; ">TYM</span>은 기계, 금속, 필터, 압연, 해외출판무역, 환경사업 등 각 분야에서 세계 제1의 제품을 생산하는데 노력하고 있습니다.
    </p>
    <p style="text-align: left;">
      이제 21세기를 동양물산은 끊임없는 연구개발과 기술혁신으로 보다 풍요로운 미래를 열어가기 위해 최선을 다할 것입니다.
    </p>
  </div>
  <div class="div">
    <p style="text-align: right; font-size: x-large; font-style: italic; position: absolute; right: 2em; line-height: 1.2em;">
      "첨단 기술로&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br />
      21세기를 연다."
    </p>
  </div>-->
  
</div>
